import { gql, useQuery } from "@apollo/client";

export const useActiveLibraryCategory = (id: string) => {
  return useQuery(gql`
    query getLibraryCategory($_id: MongoID!) {
      library_category_active(_id: $_id) {
        _id
        name
        description
        parents {
          _id
          name
        }
      }
    }
  `, 
  {
    variables: { _id: id },
    fetchPolicy: "network-only",
  }
);
}